import React from 'react'
import PropTypes from 'prop-types'
import UL from 'atoms/UL'
import SubmenuLink from 'atoms/SubmenuLink'
import { ConfigConsumer } from 'contexts/config-context'
import { BrowserConsumer } from 'contexts/browser-context'
import { ProfileConsumer } from 'contexts/profile-context'
import Accordion from 'molecules/Accordion'
import styled from 'styled-components'
import { settings } from 'contexts/settings-context'
import UserProfileTopper from './components/UserProfileTopper'

const AccordionBody = styled.div`
    padding: 12px;
    background: #f6f6f6;
    border-bottom: 1px solid #e2e2e2;
`

const LinkWrapper = UL.extend`
    padding: 12px 0;
`

const NavLinksWrapper = styled.div`
    border-bottom: 1px solid #e2e2e2;
    margin: 0 0 12px;
    padding: 0 0 12px;
      
    a > span { cursor:pointer; }
`

function Links (props) {
  const { showMainNavItems, config, isAuthenticated, onLinkClick } = props
  const standardLinks = [
    { text: 'Help', url: config.helpUrl },
  ]

  if (isAuthenticated) {
    const accountSettingsLink = { text: 'Account Settings', url: settings.ACCOUNT_SETTINGS_URL }
    if (config.accountSettingsSubItems) {
      Object.assign(accountSettingsLink, { subItems: config.accountSettingsSubItems })
    }
    standardLinks.unshift(accountSettingsLink)
    standardLinks.unshift({
      text: 'View My Transactions',
      url: `${settings.WALLET_URI}/transactions`,
    })
    standardLinks.push({ text: 'Logout', url: config.logoutUrl })
  } else {
    standardLinks.push({ text: 'Login', url: config.loginUrl })
  }

  return (
    <React.Fragment>
      {
        showMainNavItems &&
            <NavLinksWrapper>
              {
                config.navItems.map((item, index) => {
                  if (item.subItems === undefined) {
                    return <SubmenuLink key={`UserProfile-MainNav-${index}`} item={item} onClick={onLinkClick} />
                  }
                  return (
                    <Accordion
                      key={`UserProfile-${index}`}
                      trigger={<SubmenuLink item={item} />}
                      caretPosition="middle"
                    >
                      <AccordionBody>
                        {
                          item.subItems.map((subItem, subItemIndex) => {
                            if (subItem.subItems === undefined) {
                              return <SubmenuLink key={`UserProfile-SubItem-${index}-${subItemIndex}`} item={subItem} onClick={onLinkClick} />
                            }
                            return (
                              <Accordion
                                key={`Submenu-${index}`}
                                trigger={<SubmenuLink item={subItem} />}
                                caretPosition="middle"
                              >
                                <AccordionBody>
                                  {
                                    subItem.subItems.map((subSubItem, subSubItemIndex) => {
                                      return <SubmenuLink key={`Submenu-SubItem-${index}-${subSubItemIndex}`} item={subSubItem} />
                                    })
                                  }
                                </AccordionBody>
                              </Accordion>
                            )
                          })
                        }
                      </AccordionBody>
                    </Accordion>
                  )
                })
              }
            </NavLinksWrapper>
      }
      {
        standardLinks.map((item, index) => {
          if (item.subItems === undefined) {
            return <SubmenuLink key={`UserProfile-Standard-${index}`} item={item} onClick={onLinkClick} />
          }
          return (
            <Accordion
              key={`UserProfile-${index}`}
              trigger={
                <SubmenuLink item={item} />
              }
              caretPosition="middle"
            >
              <AccordionBody>
                {
                  item.subItems.map((subItem, subItemIndex) => {
                    return <SubmenuLink key={`UserProfile-Standard-SubItem-${index}-${subItemIndex}`} item={subItem} onClick={onLinkClick} />
                  })
                }
              </AccordionBody>
            </Accordion>
          )
        })
      }
    </React.Fragment>
  )
}

Links.propTypes = {
  onLinkClick: PropTypes.func,
  config: PropTypes.object.isRequired,
  showMainNavItems: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
}

function UserProfile (props) {
  const { onLinkClick } = props
  return (
    <React.Fragment>
      <UserProfileTopper />
      <ConfigConsumer>
        {config => (
          <LinkWrapper>
            <BrowserConsumer>
              {browser => (
                <ProfileConsumer>
                  {profile => {
                    if (profile.isAuthenticated === null) {
                      return null
                    }
                    return (
                      <Links
                        showMainNavItems={browser.lessThan.large}
                        config={config}
                        isAuthenticated={profile.isAuthenticated}
                        onLinkClick={onLinkClick}
                      />
                    )
                  }}
                </ProfileConsumer>
              )}
            </BrowserConsumer>
          </LinkWrapper>
        )}
      </ConfigConsumer>
    </React.Fragment>
  )
}

UserProfile.propTypes = {
  onLinkClick: PropTypes.func,
  showMainNavItems: PropTypes.bool,
}

export default UserProfile



// WEBPACK FOOTER //
// ./src/molecules/UserProfile/UserProfile.js